import {DormerRootState} from "../DormerRootState";
import {UiStatusState} from "./State";

export const getUiStatusSelector = (state: DormerRootState): UiStatusState => {
  return state.uiStatus;
}
